export const NOTIFICATION_TYPES = [
  "COMMENT_RECEIVED",
  "COMMENT_SENT",
  "COMMENT_REPLIED",
  "APPLICATION_ACCEPTED",
  "APPLICATION_SENT",
  "APPLICATION_REJECTED",
  "BUDGET_SENT",
  "BUDGET_ACCEPTED",
  "BUDGET_REJECTED",
  "QUOTATION_SENT",
  "QUOTATION_UPDATED",
  "QUOTATION_MATERIALS_UPDATED",
  "QUOTATION_ACCEPTED",
  "USER_APPLICATION_SENT",
  "USER_FEATURED_APPLICATION_SENT",
  "USER_APPLICATION_ACCEPTED",
  "USER_APPLICATION_REJECTED",
  "PROFILE_VIEW_RECEIVED",
  "PROFILE_REVIEW_RECEIVED",
  "POST_LIKED",
  "POST_COMMENTED",
  "POST_COMMENT_REPLIED",
  "POST_COMMENT_LIKED",
  "NEW_CONTACT_REQUEST",
  "NEW_MATCHES",
  "NEW_JOB_APPLICATION",
  "QUESTION_REPLIED",
  "QUESTION_RECEIVED",
  "MATERIAL_DEMAND_ALERT",
  "GENERIC_MATERIAL_DEMAND_ALERT",
  "CATEGORY_CONNECT_ACTIVITY",
] as const;

export type NotificationTypeId = (typeof NOTIFICATION_TYPES)[number];

export type HubCategory =
  | "projects"
  | "materials"
  | "account"
  | "social"
  | "work"
  | "portfolio"
  | "system";

export type HubVisualVariant = "default" | "success" | "warning" | "info";

export type HubDetailVariant = "chip" | "text";

export type HubDetailLine = {
  text: string;
  variant: HubDetailVariant;
};

export const HUB_NOTIFICATION_TYPES_VISIBLE_ONLY_TO_ADMIN = new Set<string>([
  "USER_APPLICATION_SENT",
  "USER_FEATURED_APPLICATION_SENT",
  "USER_APPLICATION_ACCEPTED",
  "USER_APPLICATION_REJECTED",
]);
